import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-nav-tabs',
  templateUrl: './ui-nav-tabs.component.html',
  styleUrls: ['./ui-nav-tabs.component.css']
})
export class UiNavTabsComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
